export const applyMaskIfNotEmpty = (value: string, mask: string): string => {
  return value !== '' ? mask : ''
}

export const applyTitleOnError = (errorTitle: string, defaultTitle: string): string => {
  return errorTitle === '' ? defaultTitle : errorTitle
}

export const hasTextMatch = (term: any, match: any): boolean => {
  return String(term).toLowerCase().includes(String(match).toLowerCase())
}

export const removeTagsHTML = (text: string): string => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(text, 'text/html')
  return doc.body.textContent !== null ? doc.body.textContent : ''
}
